import { VisibilityToggle } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import styles from "./toolbox-components.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";

interface ToolboxComponentVisibilityToggleProps {
  text: string;
  isVisible: boolean;
  onToggle: () => void;
}

export const ToolboxComponentVisibilityToggle = (
  props: ToolboxComponentVisibilityToggleProps
) => {
  return (
    <div
      className={styles.visibilityToggleContainer}
      onClick={() => {
        props.onToggle();
      }}
    >
      <span className={styles.visibilityToggleText}>{props.text}</span>
      <div style={{ opacity: props.isVisible ? 1 : 0.8 }}>
        <UIIcon
          iconName={props.isVisible ? "EYE" : "EYE-CLOSED"}
          variant="SELECTED"
          size={23}
        />
      </div>
    </div>
  );
};
